import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/workspace/layouts/admin.vue").then(m => m.default || m)),
  backend: defineAsyncComponent(() => import("/workspace/layouts/backend.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/workspace/layouts/default.vue").then(m => m.default || m)),
  game: defineAsyncComponent(() => import("/workspace/layouts/game.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/workspace/layouts/login.vue").then(m => m.default || m)),
  pattern: defineAsyncComponent(() => import("/workspace/layouts/pattern.vue").then(m => m.default || m)),
  register: defineAsyncComponent(() => import("/workspace/layouts/register.vue").then(m => m.default || m))
}